module.exports = __webpack_public_path__ + "img/slider_galery_24.7cd23755.jpg";